/**
 * Creates a function to update field values while handling special cases for 'value' and 'selection'
 * @param {Object} fieldValues - Current field values object
 * @param {Function} setFieldValues - State setter function for field values
 * @returns {Function} Update function that takes (field, key, value) parameters
 */
export const buildUpdateFieldValues = (fieldValues, setFieldValues) => (field, key, value) => {
  const current = fieldValues[field];
  const update = { [key]: value };

  if (key === 'value' && current.selection !== 'custom') {
    // don't allow value to be set unless is custom
    delete update.value;
  }
  if (key === 'value' && current.selection === 'custom') {
    // don't allow value to be set unless is custom
    update[key] = value;
  }
  if (key === 'selection' && value !== 'custom') {
    // set to selections default value
    update.value = current[value];
  }

  const future = { [field]: { ...current, ...update } };

  setFieldValues(future);
};
